var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDottedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 113,
    viewBox: "0 0 528 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999761 52.407C177.193 -123.786 425.074 231.56 590.02 66.6135",
    stroke: "#007AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "11 11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedLine);
export default __webpack_public_path__ + "static/media/dotted-line.c95cb4f0ebde5b0ec2f1f28c7a454afe.svg";
export { ForwardRef as ReactComponent };